import { TextField, Autocomplete } from '@mui/material';
import { SyntheticEvent, useEffect, useState } from 'react';
import { OptionType } from 'src/types/project';
import { useSearchParams } from 'react-router-dom';
import { statusOptions } from 'src/types/dayOffStatusOptions';

export const StatusFilter = () => {
    const [selectedOption, setSelectedOption] = useState<OptionType | null>(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const [statusId, setStatusId] = useState<string>();

    useEffect(() => {
        if (statusId) {
            const foundOption = statusOptions.find((statuses) => statuses.id == statusId);
            if (foundOption) {
                setSelectedOption(foundOption);
            }
        } else {
            setSelectedOption(null);
        }
    }, [statusId]);

    useEffect(() => {
        setStatusId(searchParams.get('status') ?? '');
    }, [searchParams]);

    const handleOnChange = (_: SyntheticEvent<Element, Event>, value: OptionType | null) => {
        if (value) {
            searchParams.set('status', value.id);
            setSearchParams(searchParams);
        } else {
            searchParams.delete('status');
            setSearchParams(searchParams);
        }
    };
    return (
        <Autocomplete
            options={statusOptions}
            value={selectedOption}
            onChange={handleOnChange}
            isOptionEqualToValue={(option, value) => option.label === value.label}
            getOptionLabel={(option) => option?.label || ''}
            renderInput={(params) => <TextField {...params} label="Status" />}
        />
    );
};
